import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function CreditsButton({ handler }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right">
      <Button onClick={handler} variant="success" size="md" className="text-success btn-link edit" title={t("common.actions.topUpCredits")}>
        <i className="fa fa-dollar-sign" />
      </Button>
    </div>
  );
}
